import React, { useContext } from 'react';

import './SymbolInfo.scss';
import AppContext from 'app/AppContext';
import SelectionStatus from 'portfolio/components/SelectionStatus';
import WidgetToolbar from 'widgets/WidgetToolbar/WidgetToolbar';
import SymbolInfoData from 'widgets/symbolInfo/SymbolInfoData';
import useWidgetStream from 'widgets/streaming/useWidgetStream';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks';
import { useWidgetContext } from 'widgets/WidgetContext';
import { usePortfolioSelection } from 'portfolio/store/hooks';
import { useSymbolValidation } from 'symbols/hooks/useSymbolValidation';
import { Icon } from '@instinet-analytics/semantic-ui-components';
import { symbolInfoStreamedDataSelectors } from 'widgets/symbolInfo/store/streamSlice';
import { DetailsPanel } from 'utils/components/DetailsPanel/DetailsPanel';

const { useWidgetMessages, useWidgetStreamData } =
    symbolInfoStreamedDataSelectors;

export default function SymbolInfo() {
    const { width } = useWidgetContext();
    useWidgetStream();

    const { numberFormat } = useContext(AppContext);

    const data = useWidgetStreamData();
    const { portfolioSelectionRequirements } =
        useWidgetPortfolioSelectionStatus();
    const messages = useWidgetMessages();

    const { selectedSymbol, symbology } = usePortfolioSelection();
    const { symbolInvalid, result: symbolValidationResult } =
        useSymbolValidation(selectedSymbol, symbology);

    return (
        <>
            <DetailsPanel className="SymbolInfo">
                <div className="panel-header">
                    <div className="toolbar">
                        <SelectionStatus
                            widgetName="Symbol Info Widget"
                            selectionRequirements={
                                portfolioSelectionRequirements
                            }
                        />
                        {symbolInvalid && (
                            <div className="SelectionStatus">
                                <div className="info-icon">
                                    <Icon name="info" />
                                </div>
                                {symbolValidationResult.symbol} is not a valid{' '}
                                {symbolValidationResult.symbology} symbol
                            </div>
                        )}
                        <div className="title" id="symbol-name">
                            {data?.name}
                        </div>
                    </div>
                    <WidgetToolbar messages={messages} />
                </div>
                {!symbolInvalid && (
                    <SymbolInfoData
                        numberFormat={numberFormat}
                        width={width}
                        data={data}
                    />
                )}
            </DetailsPanel>
        </>
    );
}
